module.exports = __webpack_public_path__ + "font/88f71b3a020f4add3be6a82edb65b456.svg"


//////////////////
// WEBPACK FOOTER
// ./app/images/preloader.svg
// module id = 412
// module chunks = 0